function SecondsFormatter(interval, format = 'long') {
    let longUnitFormatters = {
        'sec': {
            'single': 'sec',
            'plural': 'secs'
        },
        'min': {
            'single': 'min',
            'plural': 'mins'
        },
        'hour': {
            'single': 'hour',
            'plural': 'hours'
        },
        'day': {
            'single': 'day',
            'plural': 'days'
        }
    }

    let shortUnitFormatters = {
        'sec': { 'single': 's', 'plural': 's' },
        'min': { 'single': 'm', 'plural': 'm' },
        'hour': { 'single': 'h', 'plural': 'h' },
        'day': { 'single': 'd', 'plural': 'd' }
    }


    let unitFormatter = format === 'short' ? shortUnitFormatters : longUnitFormatters;

    let alertTime = 0,midvalue = 0;
    if (interval < 60)
    {
        if (interval === 1)
            alertTime = "1 " + unitFormatter['sec']['single']
        else
            alertTime = interval + " " + unitFormatter['sec']['plural'] + " "
    }
    if (60 <= interval  && interval < 3600)
    {
        midvalue = Math.round(interval/60);
        if (midvalue === 1)
            alertTime = "1 " + unitFormatter['min']['single']
        else
            alertTime = midvalue + " " + unitFormatter['min']['plural'] + " "
    }
    if (3600 <= interval && interval < 86400)
    {
        midvalue = Math.round(interval/(60*60));
    if (midvalue === 1)
            alertTime = "1 " + unitFormatter['hour']['single']
        else
            alertTime = midvalue + " " + unitFormatter['hour']['plural'] + " "
    }
    if (interval > 86400)
    {
        midvalue = Math.round(interval/(60*60*24));
        if (midvalue === 1)
            alertTime = "1 " + unitFormatter['day']['single']
        else
            alertTime = midvalue + " " + unitFormatter['day']['plural'] + " "
    }


    return alertTime
}

/**
 * Formats seconds into a detailed multi-unit format (e.g., "2 hours 10 min")
 * Shows the largest unit and the next smaller unit if there's a remainder
 * @param {number} interval - Time in seconds
 * @param {string} format - 'long' or 'short' format
 * @param {string} unit - If 'min', excludes seconds from output (only shows minutes)
 * @returns {string} Formatted time string with multiple units
 */
function SecondsFormatterDetailed(interval, format = 'long', unit = 'min') {
    let longUnitFormatters = {
        'sec': {
            'single': 'sec',
            'plural': 'secs'
        },
        'min': {
            'single': 'min',
            'plural': 'mins'
        },
        'hour': {
            'single': 'hour',
            'plural': 'hours'
        },
        'day': {
            'single': 'day',
            'plural': 'days'
        }
    }

    let shortUnitFormatters = {
        'sec': { 'single': 's', 'plural': 's' },
        'min': { 'single': 'm', 'plural': 'm' },
        'hour': { 'single': 'h', 'plural': 'h' },
        'day': { 'single': 'd', 'plural': 'd' }
    }

    let unitFormatter = format === 'short' ? shortUnitFormatters : longUnitFormatters;

    // Ensure interval is an integer to avoid floating point issues
    const totalSeconds = Math.floor(interval);

    // Calculate each unit (all as integers)
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    const parts = [];

    // Add days if present
    if (days > 0) {
        if (days === 1) {
            parts.push("1 " + unitFormatter['day']['single']);
        } else {
            parts.push(days + " " + unitFormatter['day']['plural']);
        }
        
        // If there are hours remaining, add them
        if (hours > 0) {
            if (hours === 1) {
                parts.push("1 " + unitFormatter['hour']['single']);
            } else {
                parts.push(hours + " " + unitFormatter['hour']['plural']);
            }
        }
    }
    // If no days but hours present
    else if (hours > 0) {
        if (hours === 1) {
            parts.push("1 " + unitFormatter['hour']['single']);
        } else {
            parts.push(hours + " " + unitFormatter['hour']['plural']);
        }
        
        // If there are minutes remaining, add them
        if (minutes > 0) {
            if (minutes === 1) {
                parts.push("1 " + unitFormatter['min']['single']);
            } else {
                parts.push(minutes + " " + unitFormatter['min']['plural']);
            }
        }
    }
    // If no days or hours but minutes present
    else if (minutes > 0) {
        if (minutes === 1) {
            parts.push("1 " + unitFormatter['min']['single']);
        } else {
            parts.push(minutes + " " + unitFormatter['min']['plural']);
        }
        
        // If unit is not 'min', add seconds if there are any remaining
        if (unit !== 'min' && seconds > 0) {
            if (seconds === 1) {
                parts.push("1 " + unitFormatter['sec']['single']);
            } else {
                parts.push(seconds + " " + unitFormatter['sec']['plural']);
            }
        }
    }
    // Only seconds (only show if unit is not 'min')
    else if (seconds > 0 && unit !== 'min') {
        if (seconds === 1) {
            parts.push("1 " + unitFormatter['sec']['single']);
        } else {
            parts.push(seconds + " " + unitFormatter['sec']['plural']);
        }
    }

    // If no parts (interval is 0), return appropriate zero value
    if (parts.length === 0) {
        if (unit === 'min') {
            return "0 " + unitFormatter['min']['plural'];
        }
        return "0 " + unitFormatter['sec']['plural'];
    }

    return parts.join(" ");
}

export default SecondsFormatter;
export { SecondsFormatterDetailed };